<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
  <div class="col-md-4 p-1" style="display: none">
    <span class="required-lable">Product Category :</span>
    <select name="SelectProductCategory"
            id="SelectProductCategory"
            #refSelectProductCategory="ngModel"
            disabled
            [(ngModel)]="SelectProductCategory"
            class="form-control input-text-css"
            required>
      <option value="">Select Category</option>
      <option *ngFor="let productCategory of ProductCategoryDropdown"
              [value]="productCategory.ProductCatId">
        {{ productCategory.Product_Category }}
      </option>
    </select>
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Name :</span>
    <input required
           type="text"
           #refProductName="ngModel"
           name="ProductName"
           id="ProductName"
           placeholder="Product Name"
           [(ngModel)]="ProductName"
           class="form-control input-text-css"
           disabled />
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Short Name :</span>
    <input required
           type="text"
           #refProductShortName="ngModel"
           name="ProductShortName"
           id="ProductShortName"
           disabled
           [(ngModel)]="ProductShortName"
           placeholder="Product Short Name"
           class="form-control input-text-css" />
  </div>
</div>
<div>
  <div class="d-flex align-items-center justify-content-between formborder mt-3">
    <form action="" class="search-text col-md-3">
      <div class="bg-light rounded rounded-pill shadow-sm">
        <div class="input-group">
          <input
            type="text"
            id="FilterInputSearch"
            (keyup)="applyFilter($event.target.value)"
            name="FilterInputSearch"
            placeholder="What're you searching for?"
            class="form-control border-0 bg-light"
          />
          <div class="input-group-append">
            <button
              id="button-addon1"
              type="submit"
              class="btn btn-link text-primary"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
    <button
      type="button"
      class="mt-3 btn font-size-12 button-btn"
      (click)="onAddLoanSeries()"
    >
      <i class="fa fa-plus font-size-12" aria-label="true"></i> Add
    </button>
  </div>
  <div class="table-responsive mt-3">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="Id">
        <mat-header-cell
          mat-sort-header
          class="grid-header"
          style="max-width: 6.25rem"
          *matHeaderCellDef
        >
          #
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row; let i = index"
          class="grid-cell"
          style="max-width: 6.25rem; max-height: 0.3125rem"
        >
          {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Name">
        <mat-header-cell
          mat-sort-header
          class="grid-header"
          style="max-width: 6.25rem"
          *matHeaderCellDef
        >
          Name
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="grid-cell"
          style="max-width: 6.25rem"
        >
          {{ row.Name }}
        </mat-cell>
      </ng-container>

      

      <ng-container matColumnDef="EditAction">
        <mat-header-cell
          mat-sort-header
          class="grid-header action-column"
          style="max-width: 6.25rem"
          *matHeaderCellDef
        >
          Action
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="grid-cell action-column"
          style="max-width: 6.25rem"
        >
          <!-- <i
            class="fas fa-lg fa-edit margin-right-4xs cursor-style"
            aria-label="true"
          ></i> -->
          <i
            class="fa fa-trash style-delete"
            (click)="OnDeleteSeries(row)"
            aria-label="true"
          ></i>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>

<div
  class="modal fade in"
  id="AddLSModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #f="ngForm" (ngSubmit)="onSaveNOCNames()" novalidate>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Add Names
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
            <div class="col-md-6 row m-0 p-0 align-items-center">
              <div class="col-md-4 p-1">
                <span class="required-lable"> NAME : </span>
              </div>
              <div class="col-md-8 p-1">
                <input
                  required
                  type="text"
                  #refname="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && refname.invalid,
                    'alert-warning':
                      refname.invalid &&
                      (refname.dirty ||
                        refname.touched ||
                        refname.untouched)
                  }"
                  [(ngModel)]="name"
                  placeholder="name"
                  name="name"
                  id="name"
                  class="form-control input-text-css"
                />
              </div>
            </div>
            <!-- <div class="col-md-6 row m-0 p-0 align-items-center">
              <div class="col-md-4 p-1">
                <span class="required-lable"> Accounting Category: </span>
              </div>
              <div class="col-md-8 p-1">
                <select
                  name="Loan_Accounting_CatId"
                  id="Loan_Accounting_CatId"
                  [(ngModel)]="loanSeriesModal.Loan_Accounting_CatId"
                  #refLoan_Accounting_CatId="ngModel"
                  [ngClass]="{
                    'is-invalid':
                      f.submitted && refLoan_Accounting_CatId.invalid,
                    'alert-warning':
                      refLoan_Accounting_CatId.invalid &&
                      (refLoan_Accounting_CatId.dirty ||
                        refLoan_Accounting_CatId.touched ||
                        refLoan_Accounting_CatId.untouched)
                  }"
                  class="form-control input-text-css"
                  required
                >
                  <option value="">Select Category</option>
                  <option
                    [value]="cat.Loan_CategoryId"
                    *ngFor="let cat of AccountingCatDropdown"
                  >
                    {{ cat.Loan_category }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12 row m-0 p-0 align-items-center">
              <div class="col-md-2 p-1">
                <span class="required-lable"> Products: </span>
              </div>
              <div class="col-md-10 p-1">
                <ng-multiselect-dropdown
                  name="Loan_Products"
                  id="Loan_Products"
                  [placeholder]="'Select Products'"
                  #refLoan_Products="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && refLoan_Products.invalid,
                    'alert-warning':
                      refLoan_Products.invalid &&
                      (refLoan_Products.dirty ||
                        refLoan_Products.touched ||
                        refLoan_Products.untouched)
                  }"
                  [data]="ProductDropDown"
                  [settings]="dropdownSettings"
                  [(ngModel)]="loanSeriesModal.Loan_Products"
                >
                </ng-multiselect-dropdown>
              </div>
            </div> -->
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            (click)="OnClose()"
            class="mt-3 btn font-size-12 button-btn"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="onSaveNOCNames()"
            class="mt-3 btn font-size-12 button-btn"
            [class.spinner]="loading"
            [disabled]="!f.form.valid"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
